<template>
    <div class="page-container" v-if="showList">
        <div v-if="tips.redTip" class="color-header">
            <div class="color-item">
                <i class="color red"></i>
                <span>{{tips.redTip}}</span>
            </div>
            <div class="color-item">
                <i class="color green"></i>
                <span>{{tips.greenTip}}</span>
            </div>
            <div class="color-item">
                <i class="color yellow"></i>
                <span>{{tips.yellowTip}}</span>
            </div>
        </div>
          <div class="page-container-inner">
              <div class="page-outline">
                  <div v-if="questionList.length" @click="getPage(item.pageNumber)" style="cursor: pointer"
                       :class="{'pageItem': true,'active': item.pageNumber == questionList[0].pageNumber}"
                       v-for="(item,index) in questionPageList" :key="index">
                      第{{item.pageNumber}}页 <span v-if="item.pageRemark">({{item.pageRemark}})</span>
                  </div>
              </div>
              <div class="question-list" v-loading="qsLoading"   element-loading-text="拼命加载中"  element-loading-background="rgba(0, 0, 0, 0.8)"  element-loading-spinner="el-icon-loading" >
                  <div class="quesion-root" v-if="questionList.length ">
                  <div class="read-only" v-if="type=='readonly'"></div>
                      <div v-if="questionDisabled" class="mask"></div>
                      <div v-for="(item,index) in questionList" :key="index">

                          <question-single :patient-id="patientId" @setJump="setJump" @clearJump="clearJump" :ref="item.id"
                                           :question-list="questionList"
                                           :displaySetting="item.displayNumber"
                                           :jumpSetting="item.jumpNumber" v-if="item.type == 1"
                                           :question="item"></question-single>
                          <question-multiple :patient-id="patientId" :ref="item.id" :question-list="questionList"
                                             :displaySetting="item.displayNumber"
                                             :jumpSetting="item.jumpNumber" v-else-if="item.type == 2"
                                             :question="item"></question-multiple>
                          <question-drop-down :patient-id="patientId" :ref="item.id" :question-list="questionList"
                                              :displaySetting="item.displayNumber"
                                              :jumpSetting="item.jumpNumber" v-else-if="item.type == 3"
                                              :question="item"></question-drop-down>
                          <question-completion :patient-id="patientId" :ref="item.id" v-else-if="item.type == 4"
                                               :question="item"></question-completion>
                          <question-time-select :question-list="questionList" :patient-id="patientId" :ref="item.id" v-else-if="item.type == 8"
                                                :question="item"></question-time-select>
                          <question-para :ref="item.id" v-else-if="item.type == 6" :question="item"></question-para>
                          <question-scale :patient-id="patientId" @setJump="setJump" @clearJump="clearJump" :ref="item.id"
                                          :question-list="questionList"
                                          :displaySetting="item.displayNumber"
                                          :jumpSetting="item.jumpNumber" v-if="item.type == 9"
                                          :question="item"></question-scale>
                      </div>
                  </div>
                  <div v-else>
                      <h1>题目已答完</h1>
                  </div>
                  <div class="btn-list">
                      <button v-if="pageHistoryList.length" class="submitBtn" @click="getPrevPage" :disabled="type=='readonly'">上一页</button>
                      <button v-if="questionList.length" class="submitBtn" @click="getNextPage" :disabled="type=='readonly'">下一页</button>
                  </div>
              </div>
          </div>
    </div>
</template>
<script>
    import questionSingle from './questionItemByType/question-single'
    import questionMultiple from './questionItemByType/question-Multiple'
    import questionDropDown from './questionItemByType/question-dropDown'
    import questionTimeSelect from './questionItemByType/questionTimeSelect'
    import questionCompletion from './questionItemByType/question-completion'
    import questionPara from './questionItemByType/question-para'
    import qsDetailDB from "@src/assets/qsList/indexDB.js"
    import questionScale from './questionItemByType/question-scale'
    import {
        RestNewFollowupQuestionListServiceQueryPageAndQuestionListForOnePage,
        RestNewFollowupQuestionListServiceAddPatientAnswerInfo,
        RestNewFollowupQuestionListServiceGetTips
    } from "@src/assets/js/api.js"

    import {mapGetters} from 'vuex'

    export default {
        name: 'question-root-node',
        props: {
            // questionList: { required: true }
            patientId: {required: true},
            questionDisabled: {
                default() {
                    return false
                }
            },
            questionId: { required: true },
            type: { required: false },
            // followupPatientId:{required: true}
        },
        data() {
            return {
                tips: {},
                qsLoading: false,
                showList: false,
                prevErrComponent: null,
                questionList: [],
                questionPageList: [],
                nextPage: null,
                prevPage: 0,
                pageHistoryList: [],
                statusId: null,
            }
        },
        components: {
            questionSingle,
            questionMultiple,
            questionDropDown,
            questionTimeSelect,
            questionCompletion,
            questionPara,
            questionScale
        },
        mounted() {
            this.__init()
        },
        computed: {
            ...mapGetters([
                'userid',
            ]),
        },
        watch: {
            nextPage(newValue, oldValue) {
                qsDetailDB.listenerNextPage({
                    pageNumber: newValue,
                    id: this.questionId,
                    patientId: this.patientId
                })
            },
            patientId: { // 监听路由的参数变化
                handler (val) { // 数据变化更新数据
                    console.log("下一位患者VAL",val) 
                    this.refresh();
                },
                immediate: true // 立即执行
            }
        },
        methods: {
            refresh() {
                this.showList = false
                this.__init()
            },
            __init() {
                qsDetailDB.addQsID({patientId: this.patientId, questionPageList: [], errorQuestion: []})
                let params = {
                    id: this.questionId,
                    pageNumber: this.prevPage + 1,
                    patientId: this.patientId
                }
                console.log('paient===>',{
                    followupPatientId: this.patientId,
                    questionnaireNewId: this.questionId
                })
                qsDetailDB.insertPageListById({
                    pageNumber: 1,
                    id: this.questionId,
                    patientId: this.patientId
                }, (source) => {
                    this.questionList = []
                    this.$nextTick(() => {
                        this.questionList = source.questionList
                        this.nextPage = this.questionList[0].pageNumber + 1
                        var errorQuestion = source.errorQuestion
                        if (errorQuestion.length == 1 && errorQuestion[0].title.indexOf('最后') != -1) {
                            this.lastPage()
                        }
                        this.showList = true
                    })
                })
                this.getAllQuestionList()
                this.$store.dispatch('addPatientQuestionAnswer', {
                    followupPatientId: this.patientId,
                    questionnaireNewId: this.questionId
                })
                    .then(res => {
                        console.log(res)
                        this.statusId = res.retValue.id
                    })
                this.$store.dispatch('fillTelQuestionnaireNewAnswer', {
                    followupPatientId: this.patientId,
                    questionnaireNewId: this.questionId
                })
                    .then(res => {
                        console.log(res)
                        if (params.pageNumber != 1) {
                            this.getQuestionList(params)
                        }
                    })
                this.getTipsAsync({id: this.questionId})
                    .then(res => {
                        this.tips = res.retValue
                    })
            },
            getQuestionList(p) {
                this.qsLoading = true
                qsDetailDB.getPageListById(p, (source) => {
                    this.questionList = []
                    this.questionList = source.questionList
                    this.nextPage = this.questionList[0].pageNumber + 1
                    var errorQuestion = source.errorQuestion
                    if (errorQuestion.length == 1 && errorQuestion[0].title.indexOf('最后') != -1) {
                        console.log('跳转最后页')
                        this.lastPage()
                    }
                    this.qsLoading = false
                    this.showList = true
                })

            },
            lastPage() {
                this.$store.dispatch('updatePateintQuestionAnswer', {
                    finish: 0,
                    followupPatientId: this.patientId,
                    id: this.statusId,
                    questionnaireNewId: this.questionId
                })
                    .then(res => {
                        console.log(res)
                    })
            },
            setJump(val) {
                this.nextPage = val
            },
            clearJump() {
                this.nextPage = this.questionList[0].pageNumber + 1
            },
            questionHandle(question) {
                if (question.type) {
                    question.completeConfig = question.completeConfig == '' ? {
                        'completeTextArr': [{'text1': '', 'text2': ''}],
                        'completeType': 'text',
                        'maxLength': null
                    } : JSON.parse(question.completeConfig)
                    question.bingTimeId =question.bingTimeId ? JSON.parse(question.bingTimeId) : null
                    question.timeConfigArr =question.timeConfigArr ? JSON.parse(question.timeConfigArr) : [{type: '',withBingId: '',value: ''}]
                    question.displayConfig = question.displayConfig == '' ? {'displaySettingArr': []} : JSON.parse(question.displayConfig)
                    question.scaleConfig = question.scaleConfig == '' ? [] : JSON.parse(question.scaleConfig)
                    question.jumpConfig = question.jumpConfig == '' ? {'jumpSettingArr': []} : JSON.parse(question.jumpConfig)
                    question.displayNumber = question.displayNumber == '' ? [] : JSON.parse(question.displayNumber)
                    question.jumpNumber = question.jumpNumber == '' ? [] : JSON.parse(question.jumpNumber)
                    question.dateCycle = this.getBoolean(question.dateCycle)
                    question.tipColor = question.tipColor || null
                    question.isFirst = this.getBoolean(question.isFirst)
                    question.isMust = this.getBoolean(question.isMust)
                    question.isShow = this.getBoolean(question.isShow)
                    question.manangerActive = this.getBoolean(question.manangerActive)
                    question.seqDisabled = this.getBoolean(question.seqDisabled)
                    question.paragraphConfig = question.paragraphConfig == '' ? "" : JSON.parse(question.paragraphConfig)
                    question.manangerActive = false
                    if (question.answerInfo) {
                        if (this.isJSON(question.answerInfo)) {
                            question.value = JSON.parse(question.answerInfo)
                            // question.isShow = true
                        } else {
                            question.value = question.answerInfo
                            // question.isShow = true
                        }
                    } else {
                        question.value = ''
                    }
                    question.options = question.optionsInfoRespList
                }
                return question
            },
            isJSON(str) {
                if (typeof str == 'string') {
                    try {
                        var obj = JSON.parse(str)
                        if (typeof obj == 'object' && obj) {
                            return true
                        } else {
                            return false
                        }

                    } catch (e) {
                        console.log('error：' + str + '!!!' + e)
                        return false
                    }
                }
                console.log('It is not a string!')
            },
            getBoolean(num) {
                return num == 1 ? false : true
            },


            getAllQuestionList() {
                this.$store.dispatch('getQuestionnairePageList', {questionId: this.questionId})
                    .then(res => {
                        if (res.status == 0) {
                            if (res.retValue.length) {
                                this.questionPageList = res.retValue
                            } else {
                                // 获取题目列表为空  初始部分数据
                                this.questionPageList = []
                            }
                        } else {
                            this.$message.error(res.desc)
                        }
                    })
            },

            async getNextPage() {
                var errList = []
                for (var k in this.$refs) {
                    if (this.$refs[k][0]) {
                        //console.log(this.$refs[k][0].checkIsFill())
                        if(Object.prototype.toString.call(this.$refs[k][0].checkIsFill()) === "[object Promise]") {
                            var result
                            result = await this.$refs[k][0].checkIsFill()
                            if(!result) {
                                await errList.push(this.$refs[k][0])
                            }
                        } else{
                            if(!this.$refs[k][0].checkIsFill()) {
                                //console.log(k)
                                await errList.push(this.$refs[k][0])
                            }
                        }
                    }
                }
                console.log("errList===>",errList)
                if (errList.length) {
                    if (this.prevErrComponent) {
                        this.prevErrComponent.style.border = '2px solid #fff'
                    }
                    this.prevErrComponent = errList[0].$el
                    errList[0].$el.scrollIntoView()
                    errList[0].$el.style.border = '2px dashed red'
                    this.$message.error(errList[0].question.title + '不符合规则')
                } else {
                    this.showList = false
                    if (this.prevErrComponent) {
                        this.prevErrComponent.style.border = '2px solid #fff'
                    }
                    qsDetailDB.saveListpage({
                        patientId: this.patientId,
                        pageNumber: this.questionList[0].pageNumber,
                        questionList: this.questionList
                    })

                    setTimeout(() => {
                        this.getQuestionList({
                            patientId: this.patientId,
                            id: this.questionId,
                            pageNumber: this.nextPage
                        })
                        this.pageHistoryList.push(this.questionList[0].pageNumber)
                    },2000)
                }
            },

            async getPage(page = null) {
                this.showList = false
                qsDetailDB.saveListpage({
                    patientId: this.patientId,
                    pageNumber: this.questionList[0].pageNumber,
                    questionList: this.questionList
                })
                setTimeout(() => {
                    this.getQuestionList({
                        patientId: this.patientId,
                        id: this.questionId,
                        pageNumber: page
                    })
                },200)
            },


            async getPrevPage() {
                this.showList = false
                qsDetailDB.saveListpage({
                    patientId: this.patientId,
                    pageNumber: this.questionList[0].pageNumber,
                    questionList: this.questionList
                })
                var deleteNumber = this.pageHistoryList.splice([this.pageHistoryList.length - 1], 1)
                console.log('deleteNumber', deleteNumber);
                this.$nextTick(() => {
                    this.getQuestionList({
                        id: this.questionId,
                        pageNumber: deleteNumber[0],
                        patientId: this.patientId,
                    })
                })
            },
            async getQuestionByPageAndId(p) {
                let request = new RestNewFollowupQuestionListServiceQueryPageAndQuestionListForOnePage()
                request.p_pageNumber = p.pageNumber
                request.p_questionnaireNewId = p.id || 227
                // request.p_followupPatientId = p.patientId
                await request.send()
                return request.result
            },
            //保存答案
            async saveQuestionAnswer(p) {
                let request = new RestNewFollowupQuestionListServiceAddPatientAnswerInfo()
                request.p_answerInfo = p.answerInfo
                request.p_operatorId = p.operatorId
                request.p_questionInfo = p.questionInfo
                request.p_questionnaireNewId = p.questionnaireNewId
                request.p_followupPatientId = p.patientId
                request.p_questionType = p.questionType

                await request.send()
                return request.result
            },
            async getTipsAsync(p) {
                let request = new RestNewFollowupQuestionListServiceGetTips()
                request.p_id = p.id
                await  request.send()
                return request.result
            },
        }
    }
</script>

<style lang="scss" scoped>
    .fade-enter-active, .fade-leave-active {
        opacity: 1;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }

    .color-header {
        display: flex;
        align-items: center;
        justify-content: space-around;
        padding: 10px;
        .color-item {
            display: flex;
            align-items: center;
            .color {
                margin-right: 20px;
                width: 20px;
                height: 20px;
                display: inline-block;
            }
            .red {
                background-color: red;
            }
            .green {
                background-color: green;
            }
            .yellow {
                background-color: yellow;
            }
        }

    }
    .page-container {
        height: 100%;
        .page-container-inner {
            display: flex;
            height: 100%;
            .page-outline {
                flex: .2;

                .pageItem {
                    padding: 10px;
                    text-align: left;

                    &.active {
                        background-color: #ccc;
                    }
                }
            }
            .question-list {
                height: 100%;
                overflow: auto;
                flex: .8;
                position: relative;
                .read-only {
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                    background: rgba(0,0,0,0.1);
                    z-index: 99;
                }
                .quesion-root {
                    position: relative;
                }
                .mask {
                    position: absolute;
                    z-index: 999;
                    width: 100%;
                    height: 100%;
                    left: 0;
                    top: 0;
                    background-color: rgba(0,0,0,0.1);
                }
            }
        }



    }

    .btn-list {
        text-align: center;
        padding: 10px 0 20px;
    }

    .submitBtn {
        width: 30%;
        margin-right: .1 * 100px;
        background-color: #248cfa;
        color: #fff;
        padding: .05 * 100px 0;
        border: none;
        border-radius: .05 * 100px;
    }
</style>